import { styled } from "styled-components";

export const UserControlContainer = styled.div`
  padding: 4px 8px 4px 4px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.default[50]};
  width: 100%;
  height: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  transition: background 0.2s ease-out;
  &:hover {
    background: ${({ theme }) => theme.colors.default[100]};
  }
`;

export const ProfilePictureContainer = styled.div`
  height: 32px;
  border-radius: 6px;
  aspect-ratio: 1;
  width: auto;
  background: ${({ theme }) => theme.colors.default[900]};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.base};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const Username = styled.p`
  color: ${({ theme }) => theme.colors.primary.default};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;

export const ArrowContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transform: scale(0.75);
    color: ${({ theme }) => theme.colors.default[900]};
  }
`;
